import { Star, Quote } from "lucide-react";
import { Reveal } from "./Motion";
import { useContent } from "../context/ContentContext";

const ITEMS_DEFAULT = [
  {
    q: "Zeer tevreden. Ze komen zelfs als je auto stil staat op de parkeerplaats van de Karwei om je te helpen. Kom er nu al een paar jaar en ben altijd tevreden over de service en klantvriendelijkheid.",
    bron: "Google-review",
    href: "https://g.co/kgs/f69vU2",
  },
  {
    q: "Top service, leuk personeel, ze staan altijd voor je klaar. Een topteam van vakmensen onder leiding van een topbaas — aldus een zeer tevreden klant.",
    bron: "Facebook-review",
    href: "https://www.facebook.com/Stoofvinkeveen/reviews/",
  },
];

export const Reviews = () => {
  const { get } = useContent();
  const reviews = get("reviews.items", ITEMS_DEFAULT);
  return (
    <section className="bg-primary text-white relative overflow-hidden grain" data-testid="reviews-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 relative z-10">
        <Reveal>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-accent">{get("reviews.eyebrow", "Wat klanten zeggen")}</p>
          <div className="flex items-end justify-between flex-wrap gap-4 mt-4">
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-5xl leading-[1.05] max-w-xl">
              {get("reviews.title", "Al jaren gewaardeerd in Vinkeveen")}
            </h2>
            <div className="flex items-center gap-1.5">
              {[...Array(5)].map((_, i) => <Star key={i} size={22} className="fill-accent text-accent" />)}
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <a href={r.href} target="_blank" rel="noreferrer"
                className="block h-full bg-white/[0.06] border border-white/15 p-8 hover:bg-white/[0.1] transition-colors">
                <Quote size={34} className="text-accent" />
                <p className="mt-5 text-lg leading-relaxed text-white/90">"{r.q}"</p>
                <p className="mt-6 text-sm font-semibold tracking-wide text-accent">— {r.bron}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
